// ./01 - PROJETOS DEV/meu-controle-de-estoque/src/components/modals/AddTreasuryAdjustmentModal.jsx
import React, { useState, useEffect } from 'react';

const AddTreasuryAdjustmentModal = ({ isOpen, onClose, onSave }) => {
    const initialState = {
        type: 'Entrada', // Pode ser 'Entrada' (Rendimento/Aporte) ou 'Saída' (Taxa/Despesa avulsa)
        description: '',
        amount: '',
        date: new Date().toISOString().split('T')[0]
    };

    const [formState, setFormState] = useState(initialState);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) setFormState(initialState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSaving) return;
        
        const amountValue = parseFloat(formState.amount);
        if (isNaN(amountValue) || amountValue <= 0) {
            alert('Por favor, insira um valor válido.');
            return;
        }

        setIsSaving(true);
        const adjustmentData = {
            type: formState.type,
            description: formState.description,
            amount: amountValue,
            date: new Date(`${formState.date}T00:00:00`)
        };

        try {
            await onSave(adjustmentData);
            onClose();
        } catch (error) {
            console.error("Erro ao salvar ajuste:", error);
            alert("Erro ao salvar o ajuste.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay z-50 flex items-center justify-center fixed inset-0 bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-lg m-4">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Ajuste de Caixa</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="form-label">Tipo de Movimento</label>
                            <select name="type" value={formState.type} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg">
                                <option value="Entrada">Entrada (+)</option>
                                <option value="Saída">Saída (-)</option>
                            </select>
                        </div>
                        <div>
                            <label className="form-label">Data</label>
                            <input type="date" name="date" value={formState.date} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>
                    </div>
                    <div>
                        <label className="form-label">Descrição (Ex: Rendimento, Tarifa Bancária)</label>
                        <input type="text" name="description" value={formState.description} onChange={handleChange} placeholder="Motivo do ajuste..." className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div>
                        <label className="form-label">Valor (R$)</label>
                        <input type="number" step="0.01" name="amount" value={formState.amount} onChange={handleChange} placeholder="0,00" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    
                    <div className="flex justify-end gap-4 pt-4 mt-2">
                        <button type="button" onClick={onClose} className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300">Cancelar</button>
                        <button type="submit" disabled={isSaving} className={`${formState.type === 'Entrada' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'} text-white py-2 px-6 font-semibold rounded-lg shadow-sm transition-colors`}>
                            {isSaving ? 'Salvando...' : 'Confirmar Ajuste'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTreasuryAdjustmentModal;